import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer-container" }
const _hoisted_2 = { class: "app-footer-wrapper container" }
const _hoisted_3 = { class: "app-footer-block-wrap" }
const _hoisted_4 = { class: "app-footer-block margin" }
const _hoisted_5 = { class: "app-footer-block-title" }
const _hoisted_6 = { class: "app-footer-block-text" }
const _hoisted_7 = { class: "app-footer-block-text" }
const _hoisted_8 = { class: "app-footer-block-text" }
const _hoisted_9 = { class: "app-footer-block margin" }
const _hoisted_10 = { class: "app-footer-block-title" }
const _hoisted_11 = { class: "app-footer-block-text" }
const _hoisted_12 = { class: "app-footer-block-text" }
const _hoisted_13 = { class: "app-footer-block data" }
const _hoisted_14 = { class: "app-footer-block-text non-line" }
const _hoisted_15 = { class: "app-footer-block-text-block" }
const _hoisted_16 = { class: "app-footer-block-image" }
const _hoisted_17 = { href: "https://www.linkedin.com/company/runpay-solutions-ltd" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { href: "https://www.facebook.com/RunpaySolutions" }
const _hoisted_20 = ["src"]

import {onMounted, ref} from "vue";
import {Facebook, Linkedin, useLocalizationStore} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'footerbar',
  setup(__props) {

const year = ref<number>();
const {translate} = useLocalizationStore();

onMounted(() => {
  year.value = new Date().getFullYear();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)("products_and_services")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: {name:'products-services'},
              class: "app-footer-block-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("runpay_services_solutions")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: {name:'terminal-solution'},
              class: "app-footer-block-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("terminal_solutions")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: {name:'documentation-consulting'},
              class: "app-footer-block-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("consulting_documentation")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)("about_us")), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: {name:'about-us'},
              class: "app-footer-block-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("who_we_are")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: {name:'contact-us'},
              class: "app-footer-block-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("contacts")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, "© " + _toDisplayString(year.value) + ". " + _toDisplayString(_unref(translate)("runpay_text_footer")), 1),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: {name:'privacy-policy'},
            class: "app-footer-block-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("privacy_cookie_policy_footer")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("a", _hoisted_17, [
            _createElementVNode("img", {
              src: _unref(Linkedin),
              alt: "Linkedin"
            }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("a", _hoisted_19, [
            _createElementVNode("img", {
              src: _unref(Facebook),
              alt: "Facebook"
            }, null, 8, _hoisted_20)
          ])
        ])
      ])
    ])
  ]))
}
}

})